import { render, staticRenderFns } from "./certifyAndSalesListTabs.vue?vue&type=template&id=7f01fbfc&scoped=true"
import script from "./certifyAndSalesListTabs.vue?vue&type=script&lang=js"
export * from "./certifyAndSalesListTabs.vue?vue&type=script&lang=js"
import style0 from "./certifyAndSalesListTabs.vue?vue&type=style&index=0&id=7f01fbfc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01fbfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f01fbfc')) {
      api.createRecord('7f01fbfc', component.options)
    } else {
      api.reload('7f01fbfc', component.options)
    }
    module.hot.accept("./certifyAndSalesListTabs.vue?vue&type=template&id=7f01fbfc&scoped=true", function () {
      api.rerender('7f01fbfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/salesman/components/certifyAndSalesListTabs.vue"
export default component.exports